"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStringSafeForCSV = void 0;
function makeStringSafeForCSV(note) {
    const removeCommas = note.replace(/,/g, '');
    const removeLineBreaks = removeCommas.replace(/\n+/g, ' ');
    return removeLineBreaks.trim();
}
exports.makeStringSafeForCSV = makeStringSafeForCSV;
